import { useMemo } from 'react';

import type { BillingAccount, Customer } from '@order/graphql';
import { useLocalizationContext } from '@order/Localization';

import type { CreditCardOption } from '../../Checkout.utils';

export const useCreditCardOptions = (customer: Partial<Customer>) => {
  const { t } = useLocalizationContext();
  const newCardLabel = t('checkout.add-card');

  const customerCreditCards = useMemo(
    () =>
      (customer?.billingAccounts?.map((billingAccount: BillingAccount) => ({
        value: billingAccount.id,
        label: `${
          billingAccount.nickname ? `${billingAccount.nickname} - ` : ''
        }${billingAccount.description}`,
        cardType: billingAccount.cardType,
      })) ?? []) as readonly CreditCardOption[],
    [customer?.billingAccounts],
  );

  const creditCardOptions: readonly CreditCardOption[] = useMemo(
    () => [
      {
        value: 'ADD',
        label: newCardLabel,
        cardType: 'NEW',
      },
      ...customerCreditCards,
    ],
    [customerCreditCards, newCardLabel],
  );

  return { creditCardOptions };
};
